import { useEffect, useRef } from "react";
import { observeElementOnScreen } from "../../helpers/utils";

import ButtonUI from "@UI/ButtonUI";

import code from "./img/code.svg";
import cards from "./img/cards.svg";
import timer from "./img/timer.svg";

import ym from "react-yandex-metrika";

import { createLinkClick } from '@utils'

import "./style.scss";

const Value = () => {
    const valueRef = useRef();

    useEffect(() => {
        const observer = observeElementOnScreen(valueRef.current, -100);
        return () => observer?.disconnect();
    }, []);

    const handleClick = () => {
        ym("reachGoal", 'click_connect_instrument');
        createLinkClick('#footer');
    }

    return (
        <div className="value" ref={valueRef} id="value">
            <span className="value__title">В чем наша ценность?</span>
            <div className="value__cards">
                {cardsArr.map((card, idx) => (
                    <div className="value__card" key={idx}>
                        <img src={card.img} className="value__card-img" />
                        <span className="value__card-title">{card.title}</span>
                        <span className="value__card-sub">{card.sub}</span>
                    </div>
                ))}
            </div>

            <ButtonUI className='value__btn' label="Подключить инструмент" onClick={handleClick} />
        </div>
    );
};

export default Value;

const cardsArr = [
    {
        img: code,
        title: "Отсутствие интеграции",
        sub: "Для нашего партнерства не требуется интеграция с сайтом и не нужен доступ в ваши системы аналитики",
    },
    {
        img: cards,
        title: "Эксклюзивные офферы",
        sub: "Предлагаем пользователям предложения, которых нет в свободном доступе на других ресурсах",
    },
    {
        img: timer,
        title: "Скорость ответа",
        sub: "2 простых шага и мы уже заключаем\u00A0договор",
    },
];
